module.exports = __webpack_public_path__ + "img/gateway-red.f784fcdc.png";